import * as swcHelpers from '@swc/helpers';
import { takeLatest, select, put, call, all } from 'redux-saga/effects';
import { Customers, Stores } from '@grandvisionhq/api-client';
import { Selectors, State, getToken } from '@grandvisionhq/auth';
import { ApiConfigSelectors } from '@grandvisionhq/state';
import { FETCH_LIST, FETCH_SIGNED, fetchListFailed, fetchListSuccess, fetchSignedFailed, fetchSignedSucccess } from './actions.js';
import '../../Unlink/actions.js';

function getStoreResult(apiConfig, storeId) {
    if (!apiConfig || !storeId) {
        return;
    }
    /**
   * We want to still show the prescription (without store name if this call fails. So we catch the error and don't
   * extend the prescription with store detail data, but don't send the use into a different flow.
   */ return Stores.getDetailsByCode(apiConfig.storesUrl, {
        code: storeId
    }).catch(console.error);
}
function* onFetchList() {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchListFailed(new Error(`Can't fetch prescriptions when user isn't logged-in`)));
        return;
    }
    try {
        const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
        if (!apiConfig) {
            yield put(fetchListFailed({
                message: `Can't fetch stores without API Config`
            }));
            return;
        }
        const token = yield call(getToken);
        const response = yield call(Customers.Prescriptions.list, auth.apiUrl, token, {
            customerId: auth.userId
        });
        // Build store fetch call effects
        const storeFetchResults = response.reduce((m, prescription)=>{
            if (!prescription.storeId) {
                return m;
            }
            return swcHelpers.objectSpread({}, m, {
                [prescription.storeId]: call(getStoreResult, apiConfig, prescription.storeId)
            });
        }, {});
        const storeResponse = yield all(storeFetchResults);
        // Add store name to prescription
        const result = response.map((prescription)=>{
            var ref;
            return swcHelpers.objectSpread({}, prescription, {
                storeName: prescription.storeId && ((ref = storeResponse[prescription.storeId]) === null || ref === void 0 ? void 0 : ref.storeName)
            });
        });
        yield put(fetchListSuccess(result));
    } catch (err) {
        yield put(fetchListFailed(swcHelpers.objectSpread({}, err)));
    }
}
function* onFetchSigned() {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchSignedFailed(new Error(`Can't fetch signed prescriptions when user isn't logged-in`)));
        return;
    }
    try {
        const token = yield call(getToken);
        const response = yield call(Customers.Prescriptions.signedPrescriptions, auth.apiUrl, token, {
            customerId: auth.userId
        });
        yield put(fetchSignedSucccess(response.prescriptionTokens));
    } catch (err) {
        yield put(fetchSignedFailed(swcHelpers.objectSpread({}, err)));
    }
}
var prescriptionsSagas = [
    takeLatest(FETCH_LIST, onFetchList),
    takeLatest(FETCH_SIGNED, onFetchSigned), 
];

export { prescriptionsSagas as default, getStoreResult, onFetchList, onFetchSigned };
//# sourceMappingURL=sagas.js.map
